'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideosRatingModalContainer = exports.VideosRatingsModalUnwrapped = exports.modalConfig = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _bound = require('redux/saga/entities/bound');

var _rating = require('redux/modules/rating');

var _Videos = require('./Videos.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    rating: state.rating,
    video: _bound.videoViewRatings.select(state)
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  rateVideo: _Videos.rateVideo,
  updateRating: _rating.updateRating,
  updateComment: _rating.updateComment,
  invalidRating: _rating.invalidRating
};

var modalConfig = exports.modalConfig = {
  headerClass: 'modal__video-rating'
};

var VideosRatingsModalUnwrapped = exports.VideosRatingsModalUnwrapped = function (_React$Component) {
  (0, _inherits3.default)(VideosRatingsModalUnwrapped, _React$Component);

  function VideosRatingsModalUnwrapped(props) {
    (0, _classCallCheck3.default)(this, VideosRatingsModalUnwrapped);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (VideosRatingsModalUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(VideosRatingsModalUnwrapped)).call(this, props));

    _this2.state = {
      disableSubmit: true
    };
    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
    return _this2;
  }

  (0, _createClass3.default)(VideosRatingsModalUnwrapped, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.video.data.length === 0) {
        return false;
      }
      return true;
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit() {
      var _props = this.props,
          rating = _props.rating,
          localRateVideo = _props.rateVideo,
          userId = _props.userId,
          video = _props.video,
          localInvalidRating = _props.invalidRating;


      this.setState({ disableSubmit: true });
      if (rating.stars) {
        this.textInput.value = '';
        localRateVideo(userId, {
          video_event_id: video.data[0].video_event_id,
          rating: rating.stars,
          comment: rating.comment
        });
      } else {
        localInvalidRating();
      }
    }
  }, {
    key: 'handleUpdateRating',
    value: function handleUpdateRating(star) {
      this.props.updateRating(star);
      this.setState({ disableSubmit: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var _props2 = this.props,
          video = _props2.video,
          rating = _props2.rating,
          localUpdateComment = _props2.updateComment;
      var _video$data$ = video.data[0],
          title = _video$data$.title,
          partner = _video$data$.partner,
          instructor = _video$data$.instructor;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'modal__header modal__header--img pv++', style: { backgroundImage: 'url("' + video.data[0].thumbnail_large_url + '")' } },
          _react2.default.createElement(
            'div',
            { className: 'modal__header__text' },
            _react2.default.createElement(
              'h4',
              null,
              title
            ),
            _react2.default.createElement(
              'p',
              null,
              partner.name
            ),
            _react2.default.createElement(
              'p',
              null,
              instructor
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'modal__content pv++ text--center' },
          _react2.default.createElement(
            'h4',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'modal.ratings.h4',
              defaultMessage: 'How was your workout?'
            })
          ),
          _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)('ratings ratings--form', (0, _defineProperty3.default)({}, 'ratings--rated-' + rating.stars, true))
            },
            ['1', '2', '3', '4', '5'].map(function (star) {
              return _react2.default.createElement(
                'div',
                { className: 'ratings__star' },
                _react2.default.createElement('input', { type: 'radio', name: 'rating', value: star, onClick: _this.handleUpdateRating.bind(_this, star) })
              );
            })
          ),
          _react2.default.createElement(
            'p',
            {
              className: (0, _classnames2.default)('error__text', {
                hidden: !rating.invalid
              })
            },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'modal.ratings.star.error',
              defaultMessage: 'Please select a star rating'
            })
          ),
          _react2.default.createElement('textarea', {
            className: 'mt- mb',
            onBlur: function onBlur(e) {
              return localUpdateComment(e.target.value);
            },
            ref: function ref(el) {
              return _this.textInput = el;
            },
            rows: '3',
            cols: '30',
            placeholder: 'Leave a review of this class to inform others in the ClassPass community.'
          }),
          _react2.default.createElement(
            'div',
            { className: 'text--center' },
            _react2.default.createElement(
              'button',
              { onClick: this.handleSubmit, disabled: this.state.disableSubmit, className: 'bt bt--primary bt--lg bt--width-md' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'modal.ratings.submit',
                defaultMessage: 'Submit'
              })
            )
          )
        )
      );
    }
  }]);
  return VideosRatingsModalUnwrapped;
}(_react2.default.Component);

VideosRatingsModalUnwrapped.propTypes = {
  invalidRating: _propTypes2.default.func.isRequired,
  rating: _propTypes2.default.object.isRequired,
  rateVideo: _propTypes2.default.func.isRequired,
  updateRating: _propTypes2.default.func.isRequired,
  updateComment: _propTypes2.default.func.isRequired,
  userId: _propTypes2.default.number.isRequired,
  video: _propTypes2.default.object.isRequired
};

var VideosRatingModalContainer = exports.VideosRatingModalContainer = (0, _Modal2.default)(modalConfig)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VideosRatingsModalUnwrapped));